import React, {Component} from 'react';
import './shopContact.scss';
import {env} from "../../../shared/environment";
import ShopGoogleMap from './ShopGoogleMap/ShopGoogleMap';
import {Link} from 'react-router-dom';
import {animateScroll as scroll} from "react-scroll";
import {AlifshopLink} from './AlifshopLink/AlifshopLink';

class ShopContact extends Component {
    baseUrl = env.baseUrl;

    constructor(props) {
        super(props);
        this.state = {
            contact: null
        }
        this.scrollToTop = this.scrollToTop.bind(this);
    }

    scrollToTop() {
        scroll.scrollTo(500);
    }

    render() {
        let categories = [];
        let imgSrc = '';

        if (this.props && this.props.categories) {
            const hashtags = this.props.categories.filter(c => c.name.slice(0, 1) === '#')
            const filtered = this.props.categories.filter(c => c.name.slice(0, 1) !== '#')
            const sorted = [...filtered, ...hashtags]
            categories = sorted.map((category) => {
                return (
                    <Link
                        to={`/partners?ce=${category.id}&`}
                        onClick={this.scrollToTop}
                        key={category.id}
                    >
                        <button className={category.name.slice(0, 1) === '#' ? 'primary' : ''}>
                            {category.name}
                        </button>
                    </Link>

                );
            });

        }
        imgSrc = this.props.img;

        function mssn(v) {
            let r = v.replace(/\D/g, "");
            r = r.replace(/^0/, "");
            let n = r.slice(3, 5)
            if (n === '48' || n === '37') {
                r = r.replace(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2}).*/, "+$1 ($2) $3-$4-$5 ");
            } else {
                r = r.replace(/^(\d{3})(\d{2})(\d{3})(\d{2})(\d{2}).*/, "+$1 $2 $3-$4-$5 ");
                return r;
            }
            return r;
        }

        const splitNumbers = (value) => {
            if (value.length > 12) {
                return value.split(',').map(element => {
                    return mssn(element) + '\r\n';
                });
            } else {
                return mssn(value);
            }
        }

        return (
            <div className="ShopContact">
                <div className="container">
                    <div className="row ctm-row-one">
                        <div className="col-12 col-md-4 ctm-shops-img-container mb-4 mt-md-0">
                            {this.props && this.props.img ?
                                <img src={this.baseUrl + 'images/' + imgSrc} alt="ShopsName"/> : ''}
                        </div>
                        <div className="col-12 col-md-8 ctm-shops-address-container">

                            <div className="ctm-shops-address-title">
                                {this.props && this.props.contacts && this.props.contacts.length ? this.props.contacts[0].partner : ''}
                            </div>

                            <div className="ctm-shops-description-text">
                                {this.props && this.props.description
                                    ? <span dangerouslySetInnerHTML={{__html: this.props.description}}/>
                                    : null}
                            </div>

                            <div className="ctm-shops-address-button-container">{categories}</div>

                            {this.props && this.props.contacts && this.props.contacts.length ? this.props.contacts.map(o => {
                                return (
                                    <div key={o.id} onClick={
                                        () => {
                                            this.props.contacts.length > 1
                                            && this.setState({contact: o})
                                        }
                                    }
                                         className={`ctm-shops-address-text ${this.props.contacts.length <= 1
                                             ? "not-allowed" : ""}`}
                                    >
                                        {o.address} <br/>
                                        <p className='breaking-line'>{splitNumbers(o.phone)}</p>
                                    </div>
                                )
                            }) : ''}
                            {
                                this.state.contact ? <ShopGoogleMap shop={this.state.contact}/>
                                    : this.props && this.props.contacts && this.props.contacts.length ?
                                    <ShopGoogleMap shop={this.props.contacts[0]}/> : ''
                            }

                            {
                                this.props && this.props.alifshopLink
                                    ? <AlifshopLink alifshopLink={this.props.alifshopLink}/>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default ShopContact;
